export class Education {
  constructor () {
    this.id = null
    this.trainerId = ''
    this.college = ''
    this.degree = ''
    this.description = ''
    this.specialization = ''
    this.startDate = ''
    this.endDate = ''
  }
}



// WEBPACK FOOTER //
// ./src/models/Education.js